import React, { useMemo, useState, useEffect } from 'react';
import './LinesSection.css';

const LinesSection = ({ 
  purpleCount = 4, 
  purpleSpacing = 4, 
  startPosition = 15, 
  gap = 25,
  questions = [
    "Which spreadsheet does everyone secretly depend on?",
    "Which subscription has nobody used in months?",
    "Which process lives in one person's head and nowhere else?",
    "How much are you paying for tools you've outgrown?"
  ]
}) => {

  // Generate purple line positions based on props
  const lines = useMemo(() => {
    const purplePositions = [];
    for (let i = 0; i < purpleCount; i++) {
      purplePositions.push(startPosition + (i * (purpleSpacing + 1)));
    }
    let questionIndex = 0;

    return Array.from({ length: 150 }, (_, index) => {
      const isPurple = purplePositions.includes(index);
      const width = isPurple ? 8 : Math.floor(Math.random() * 4) + 2;
      const backgroundColor = isPurple ? '#9579FC' : '#1a1a1a';
      const question = isPurple ? questions[questionIndex++] : null;
      
      return {
        width,
        backgroundColor,
        question
      };
    });
  }, [purpleCount, purpleSpacing, startPosition, questions]);

  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [displayedText, setDisplayedText] = useState({});

  useEffect(() => {
    if (hoveredIndex !== null && lines[hoveredIndex].question) {
      const fullText = lines[hoveredIndex].question;
      let currentIndex = 0;
      
      const interval = setInterval(() => {
        if (currentIndex <= fullText.length) {
          setDisplayedText(prev => ({
            ...prev,
            [hoveredIndex]: fullText.slice(0, currentIndex)
          }));
          currentIndex++;
        } else {
          clearInterval(interval);
        }
      }, 20); // 20ms per character for faster typing

      return () => clearInterval(interval);
    } else if (hoveredIndex === null) {
      setDisplayedText({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hoveredIndex]);

  return (
    <div className="lines-container" style={{ gap: `${gap}px` }}>
      {lines.map((line, index) => (
        <div 
          key={index} 
          className={`line-item ${line.backgroundColor === '#9579FC' ? 'purple-line' : ''}`}
          style={{ 
            width: `${line.width}px`,
            backgroundColor: line.backgroundColor
          }}
          onMouseEnter={() => line.question && setHoveredIndex(index)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          {line.question && (
            <div className={`question-text ${hoveredIndex === index ? 'typing' : ''}`}>
              {displayedText[index] || ''}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default LinesSection;

